const optionPointerUp = ({ currentIndex, options, exclude, scrollEl, refs }) => {
  let index = (currentIndex - 1 + options.length) % options.length;
  if (typeof exclude === 'function') {
    for (let i = 0; i < options.length; i++) {
      if (exclude(options[index])) break;
      index = (index - 1 + options.length) % options.length;
    }
  }

  if (isNaN(index)) {
    index = 0;
  }

  scrollEl && refs && optionPointerScroll({ scrollEl, refs, index });
  return index;
}

const optionPointerDown = ({ currentIndex, options, exclude, scrollEl, refs }) => {
  let index = (currentIndex + 1) % options.length;
  if (typeof exclude === 'function') {
    for (let i = 0; i < options.length; i++) {
      if (exclude(options[index])) break;
      index = (index + 1) % options.length;
    }
  }

  if (isNaN(index)) {
    index = 0;
  }

  scrollEl && refs && optionPointerScroll({ scrollEl, refs, index });
  return index;
}

const optionPointerScroll = ({ scrollEl, refs, index }) => {
  try {
    const optionEl = refs[`dropdown-option-${index}`][0].$el ? refs[`dropdown-option-${index}`][0].$el : refs[`dropdown-option-${index}`][0];
    if (optionEl) {
      const bounds = getElBoundingClientRect(scrollEl);
      const { top, bottom, height } = optionEl.getBoundingClientRect();
      let offsetHeight = 0;
      try {
        if (scrollEl.classList.contains('dropdown-menu--sticky')) {
          offsetHeight = [...scrollEl.getElementsByClassName('dropdown-filter')].reduce((accumulator, element) => accumulator += element.offsetHeight, 0);
        }
      } catch (err) { console.warn(err); }
      if (top < (bounds.top + offsetHeight)) {
        scrollEl.scrollTop = optionEl.offsetTop - offsetHeight;
      } else if (bottom > bounds.bottom) {
        scrollEl.scrollTop = optionEl.offsetTop - (bounds.height - height);
      }
    }
  } catch (err) { console.warn(err); }
}

const getElBoundingClientRect = (el) => el ?
  el.getBoundingClientRect() :
  {
    height: 0,
    top: 0,
    bottom: 0
  }

export default {
  optionPointerUp: optionPointerUp,
  optionPointerDown: optionPointerDown
}